export default {
    RTTB: 'Roll to the bottom'
}